import React, { useState, useEffect } from "react";
import "./mustDoActionDataPointInput.css";
import {
  InputLengthValidations,
  SingleMustDoDataPointState,
} from "../../types";
import { checkIfInputIsUnique } from "../../mustDoActionService";
interface MustDoActionDataPointInputProps {
  label: string;
  value: string | number; // Depending on the type of value you expect
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  datapoints: Array<SingleMustDoDataPointState>;
  inputLengthValidations: InputLengthValidations;
}

const MustDoActionDataPointInput: React.FC<MustDoActionDataPointInputProps> = ({
  label,
  value,
  name,
  onChange,
  placeholder,
  datapoints,
  inputLengthValidations,
}) => {
  const maxLength =
    name.toLowerCase() === "unit"
      ? inputLengthValidations.max.unit
      : inputLengthValidations.max.title;
  const minLength =
    name.toLowerCase() === "unit"
      ? inputLengthValidations.min.unit
      : inputLengthValidations.min.title;

  const getErrorMessage = (input: string): string => {
    if (input.length < minLength) {
      return `Input must be at least ${minLength} characters.`;
    }
    // else if (input.length > maxLength) {
    //   return `Input cannot exceed ${maxLength} characters.`;
    // }
    else if (
      name !== "heading" &&
      !checkIfInputIsUnique(datapoints, name, input)
    ) {
      return "Input must be unique";
    } else {
      return ""; // Clear error message if valid
    }
  };
  const [errorMessage, setErrorMessage] = useState<string>(
    getErrorMessage(value as string)
  );
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue.length < maxLength) {
      // Validate the new input length
      setErrorMessage(getErrorMessage(newValue));

      onChange(e); // Call the passed onChange handler to update the parent component
    }
  };
  useEffect(() => {
    setErrorMessage(getErrorMessage(value as string));
  }, [datapoints]);
  return (
    <div style={{display:"flex",flexDirection:"column" , justifyContent:"center",alignItems:"center", gap:'4px'}} className="mustDoActionDataPointInput-container">
      <label className="mustDoActionDataPointInput-label">{label}</label>
      <div className="mustDoActionDataPointInput-input-and-error-container">
        <input
          className="mustDoActionDataPointInput-form"
          type="text"
          value={value}
          name={name}
          onChange={handleInputChange}
          placeholder={placeholder}
          style={{textTransform: name === "heading" ? "uppercase" : "none"}}
        />
        {errorMessage && (
          <div className="mustDoActionDataPointInput-error">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default MustDoActionDataPointInput;
